"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Vehicles = function () {
  function Vehicles($q, API) {
    _classCallCheck(this, Vehicles);

    this.$q = $q;
    this.API = API;
  }

  _createClass(Vehicles, [{
    key: "getVehicleList",
    value: function getVehicleList(groupIds) {
      var targetAccount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var baseUrl = "v1/vehiclelist";
      var param = [];
      param.push.apply(param, this.API.getArrayQuery("includeGroupIds", groupIds));

      if (targetAccount !== null) {
        param.push("targetAccount=" + targetAccount);
      }
      var query = "";
      if (param.length > 0) {
        query += "?" + param.join("&");
      }

      var url = baseUrl + query;
      var ctx = this;
      var promise = new Promise(function (resolve, reject) {
        ctx.API.get(url).success(function (vehicles) {
          return resolve(vehicles);
        }).error(function (err) {
          return reject(err);
        });
      });
      return promise;
    }

    // TODO: DEPRECATE due to performance with 20k+ items

  }, {
    key: "getVehicles",
    value: function getVehicles(groupIds, searchTerm, paging) {
      var targetAccount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var deferred = this.$q.defer();
      var url = "v1/vehicles";

      var param = [];
      param.push.apply(param, this.API.getPagingQuery(paging));
      param.push.apply(param, this.API.getArrayQuery("includeGroupId", groupIds));
      if (searchTerm) param.push("searchTerm=" + searchTerm);

      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (vehicles) {
        //console.log("vehicles: ", vehicles);
        deferred.resolve(vehicles);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return Vehicles;
}();

exports.default = Vehicles;


Vehicles.$inject = ["$q", "FleetPortalAPI"];


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.vehicles.js